export class TermFilter {
  searchFilter: any;
    public pgNumber: number;
    public pgSize: number;
    public searchTerm: string;

}
